/**
 * Czyści dynamicznie wstawianą zawartość głównego modala po jego zamknięciu.
 * Część widoków otwiera #popup_container bez pośrednictwa jsKit.
 */
export const initPopupContainerCleanup = () => {
  const popupContainer = document.getElementById('popup_container');

  popupContainer?.addEventListener('hidden.bs.modal', () => {
    popupContainer.querySelector('.modal-content')?.replaceChildren();
  });
};

/**
 * Obsługuje modale otwierane bezpośrednio przez Bootstrap, poza jsKit.
 */
export const initModalAutofocus = () => {
  document.addEventListener('shown.bs.modal', ({ target: modal }) => {
    const autofocusInput = modal.querySelector('input[autofocus]:not([type="hidden"])');

    if (autofocusInput && autofocusInput.offsetParent !== null) {
      autofocusInput.focus();

      if (autofocusInput.type === 'text') {
        autofocusInput.setSelectionRange(autofocusInput.value.length, autofocusInput.value.length);
      }
    }
  });
};
